import { DesignIconNames } from '@monorepo/nova-icons';
import { PurchaseStatus } from '@monorepo/types';

export const getStatusIcon = (
  status: PurchaseStatus | undefined,
  isDarkMode: boolean,
): DesignIconNames => {
  switch (status) {
    case PurchaseStatus.Failed:
      return isDarkMode ? 'Card' : 'Card';
    case PurchaseStatus.Canceled:
      return 'SadSmiley';
    case PurchaseStatus.Pending:
      return 'HourGlass';
    case PurchaseStatus.Completed:
      return isDarkMode ? 'AllSetDark' : 'AllSet';
    default:
      return 'HourGlass';
  }
};

export const getStatusTitle = (status: PurchaseStatus | undefined): string => {
  switch (status) {
    case PurchaseStatus.Completed:
      return 'All Set!';
    case PurchaseStatus.Failed:
      return 'Payment Failed';
    case PurchaseStatus.Pending:
      return 'Processing...';
    default:
      return 'All Set!';
  }
};

export const getStatusDescription = (
  snapshotId: string | undefined,
  status: PurchaseStatus | undefined,
): string => {
  if (!snapshotId || !status) {
    return 'Hang tight as we set up your account';
  }

  switch (status) {
    case PurchaseStatus.Pending:
      return 'Hang tight as we process your payment.';
    case PurchaseStatus.Failed:
      return 'please try again or use a different method.';
    case PurchaseStatus.Completed:
      return 'Hang tight as we set up your account';
    default:
      return 'Hang tight as we process your payment.';
  }
};

export const getRedirectMessage = (
  snapshotId: string | undefined,
  status: PurchaseStatus | undefined,
): string => {
  if (!snapshotId || !status) {
    return 'You will be automatically redirected to your new dashboard';
  }

  switch (status) {
    case PurchaseStatus.Failed:
      return ''; // No redirect message for failed state - we show retry button instead
    case PurchaseStatus.Completed:
      return 'You will be automatically redirected to your new dashboard';
    case PurchaseStatus.Pending:
      return 'You will be automatically redirected when processing is complete';
    default:
      return 'You will be automatically redirected when processing is complete';
  }
};
